import axios from "../axiosApi";

import {
     FETCH_DOF,
    
    FETCH_ESTRUTURA_DISCIPLINAS, RECEIVE_DOF,
    
    RECEIVE_ESTRUTURA_DISCIPLINAS,
    
} from "../actionTypes";




// interface iEstruturaLevelDisciplinasResponse {
//     error? : boolean,
//     data? : iLevel
// }

export const fetchEstruturaDiscs =  () => ({
    type: FETCH_ESTRUTURA_DISCIPLINAS
});

export const receiveEstruturaDiscs = (payload: any) => ({
    type: RECEIVE_ESTRUTURA_DISCIPLINAS,
    payload: payload
});

export const fetchDOF =  () => ({
    type: FETCH_DOF
});

export const receiveDOF = (payload: any) => ({
    type: RECEIVE_DOF,
    payload: payload
});


export const getEstruturaLevelDisciplinas = () => {
    return async (dispatch : any, getState: any ) => {
        if (getState().isFetchingAlunos) { return null; }
        dispatch(fetchEstruturaDiscs());
        let payload;

        try {
            const url = `/Levels?filter={  "include": [  {"discipline": "disciplineModule"}  ]  }`;
            const response = await axios.get(url);
            console.log('getEstruturaLevelDisciplinas response', response);
            payload = response.data
        }
        catch(e) {
            payload = [];
            console.log("ERROR getEstruturaLevelDisciplinas ", e);

        }
        finally {
            dispatch(receiveEstruturaDiscs(payload));
        }
    }
}

export const getDOF = () => {
    return async (dispatch : any, getState: any ) => {
        if (getState().isFetchingDOFOpen) { return null; }
        dispatch(fetchDOF());
        let payload;
        
        try {
            const url = `/DisciplineOffers?filter={  "include": [ "classOffer", "period", { "disciplineModule" : "discipline" } ] }`;
            const response = await axios.get(url);
            
            console.log("DOF Response", JSON.stringify(response.data,null,4));
          
            payload = response.data
        }
        catch(e) {
            payload = [];
            console.log("getClasses ERROR", e);
            
        }
        finally {
            dispatch(receiveDOF(payload));
        }
    }
}

